import { deriveLinearConversionFactors } from "../../Units/UnitConversion.js";
import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

type LinearConfig = SensorElementConfig<Record<string, never>, typeof SensorConversions.linearWithMinAndMax>;

const { slope, offset } = deriveLinearConversionFactors("inch", "millimeter");

export const imperialEvapotranspirationElementConfig: LinearConfig = {
    legalConvertedRange: [0, null],
    conversionKey: "linearWithMinAndMax",
    parameterConfigs: {},
    buildConversionParams: () => ({
        slope,
        offset,
        outputMin: 0,
        outputMax: Number.MAX_VALUE,
    }),
    decodedUnits: "inch",
    convertedUnits: "millimeter",
    unitCategory: "evapotranspiration",
    testCases: [
        { parameters: {}, decodedValue: 0, convertedValue: 0 },
        { parameters: {}, decodedValue: 0.1, convertedValue: 2.54 },
    ],
} as const;
